import type { ExtensionsCommandFactory } from '../ExtensionsModel';
import { getExtensions } from './api/getExtensionsApi';
import { unregisterExtension as unregisterExtensionApi } from './api/unregisterExtensionApi';

type UnregisterExtensionCommand = {
  extensionId: string;
};

export const unregisterExtension: ExtensionsCommandFactory<
  UnregisterExtensionCommand
> = (cmdContext) => async (command) => {
  try {
    cmdContext.updateState((draft) => {
      draft.extensionsLoading = true;
    });
    await unregisterExtensionApi(command.extensionId, cmdContext.api);
    const response = await getExtensions(cmdContext.api);

    cmdContext.updateState((draft) => {
      draft.extensions = [...response.extensions];
    });
  } finally {
    cmdContext.updateState((draft) => {
      draft.extensionsLoading = false;
    });
  }
};
